<template>
    <ul v-bind="$attrs" class="flex flex-col gap-4">
        <li v-for="(value, index) of chapters" :key="index" class="rounded-lg cursor-pointer hover:drop-shadow-lg hover:border-2 hover:border-solid hover:border-blue-600"
            @click="clickedPlayed(index, value.id)">
                <div class="box-border flex flex-row gap-2 px-4">
                    <div class="flex flex-col w-full grow">
                        <div class="flex items-center w-full gap-2 py-4 text-2xl text-pink-700 border-b border-gray-200 border-solid">
                            <div class="w-11/12 text-md">
                                <span class="text-md">{{ index+1 }}{{ index+1 ? "." : "" }} </span>
                                <span>{{ value["title"] }}</span>
                            </div>
                            <div>                                
                                <div v-if="index === Number($cookies.get('chapterIndex')) && currentAudioId === Number($cookies.get('audioId')) && value.id === Number($cookies.get('chapterId'))" class="flex items-center justify-center">
                                    <img src="/img/icons/green-arrow.png" />
                                </div>
                                <div v-else>
                                    <div v-if="!value.isCompleted && updatedIndex === index" class="flex items-center justify-center">
                                        <img src="/img/icons/green-arrow.png" />
                                    </div>
                                    <div v-else-if="value.isCompleted && updatedIndex !== index" class="flex items-center justify-center">
                                        <img class="w-12 h-10" src="/img/icons/audioBookCompletedTick.svg" />
                                    </div>
                                    <div v-else-if="value.isCompleted && updatedIndex === index" class="flex items-center justify-center">
                                        <img class="w-12 h-10" src="/img/icons/audioBookCompletedTick.svg" />
                                    </div>
                                    <div v-else class="flex flex-row items-center">
                                        <button class="disable-ripple" title="Play chapter">
                                            <img v-if="value.status == 1 && !value.isCompleted && updatedIndex !== index" class="w-12 h-10" src="/img/icons/audioBookCompletedTick.svg" />
                                            <img v-else-if="!value.isCompleted && updatedIndex !== index" src="/img/icons/red-arrow.png" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            <!-- <audio-book-chapter-details :details="value" :is-completed="!!value.isCompleted" :extras="index+1"/> -->
        </li>
    </ul>
</template>

<script>
    // import AudioBookChapterDetails from "@/Components/AudioBookChapterDetails";

    export default {
        name: "AudioBookChapter",
        // components: {AudioBookChapterDetails},
        props: {
            chapters: Array,
            autoPlay: {
                type: Number,
                default: () => 0
            },
            updatedIndex: {
                type: Number,
                default: () => null
            },
            currentAudioId: {
                type: Number,
                default: () => 0
            },
        },
        methods: {
            clickedPlayed(e, value) {
                this.$emit("play", e);
                this.$emit("playedChapterId", value);
                this.currentAudio = e;
                this.chapters[e].isCompleted = false;
            },
        }
    };
</script>
